import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/hot", label: "热点榜" },
  { to: "/category/yule", label: "娱乐八卦" },
  { to: "/category/zongyi", label: "综艺现场" },
  { to: "/category/shehui", label: "社会热点" },
  { to: "/category/wangluo", label: "网络热梗" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200/70" : "bg-background-50"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-3">
          {/* 品牌 */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="relative flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50 shadow-sm">
              <span className="font-heading text-lg md:text-xl font-black leading-none">瓜</span>
              <span className="absolute -right-1 -top-1 flex h-3 w-3 rounded-full bg-accent-400 ring-2 ring-background-50" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-black tracking-tight text-foreground-950">
                吃瓜现场
              </span>
              <span className="mt-1 text-[11px] text-foreground-600 hidden sm:block">
                免下载 · 在线看 · 实时刷新
              </span>
            </span>
          </Link>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-800 hover:bg-primary-100/70 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* 右侧操作 */}
          <div className="flex items-center gap-2.5">
            <Link
              to="/faq"
              className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100/60 px-4 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-200/70 cursor-pointer"
            >
              <i className="ri-lifebuoy-line text-base" aria-hidden="true"></i>
              常见问题
            </Link>
            <Link
              to="/about"
              className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer"
            >
              <i className="ri-customer-service-2-line text-base" aria-hidden="true"></i>
              在线投稿
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              aria-expanded={open}
              className="lg:hidden flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-900 cursor-pointer"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav
          className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3"
          aria-label="移动端导航"
        >
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-center whitespace-nowrap rounded-xl px-3 py-2.5 text-sm font-medium cursor-pointer ${
                    isActive ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            <Link
              to="/faq"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-1.5 rounded-xl border border-background-300 px-3 py-2.5 text-sm text-foreground-800 cursor-pointer"
            >
              <i className="ri-lifebuoy-line" aria-hidden="true"></i> 常见问题
            </Link>
            <Link
              to="/about"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-1.5 rounded-xl bg-foreground-950 px-3 py-2.5 text-sm text-background-50 cursor-pointer"
            >
              <i className="ri-customer-service-2-line" aria-hidden="true"></i> 在线投稿
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}